import React, { useState } from 'react';
import styled from "styled-components";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import axios from 'axios';
// import liked from "./liked";

const SongCardMain = styled.main`
    width:100%;
    height:100px;
    display:flex;
    .FavoriteIconDiv{
        display:flex;
        justify-content:center;
        align-items:center;
        box-sizing: border-box;
        height:80px;
        width:80px;
    }
    .info{
        height:100px;
        width:400px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-wrap:wrap;
        
    }
    .DeleteIconDiv{
        box-sizing: border-box;
        height:80px;
        width:60px;
    }
 
`;

export default function SongCard(props) {
    console.log(props.info, "props in song card");
    const [liked, setLiked] = useState(false);

    const addToLiked = (event) => {
        event.preventDefault();
        setLiked(true);
        // axios
        // .post()
        // .then(res =>{
        //     console.log(res, "response from liking a song")
        // })
        // .catch(err => {
        //     console.log(err, "error from liking a song")
        // })

    }
    const deleted = (event) => {
        event.preventDefault();
        setLiked(false);
        // axios
        // .delete()
        // .then(res =>{
        //     console.log(res, "response from liking a song")
        // })
        // .catch(err => {
        //     console.log(err, "error from liking a song")
        // })
    }

    if (props.info) {
        return (
            <SongCardMain>
                <div className="FavoriteIconDiv" id={props.info.id} onClick={addToLiked}>
                    <FavoriteBorderIcon className={(!liked) ? "dodisplay" : "dontdisplay"}></FavoriteBorderIcon>
                    <FavoriteIcon className={(liked) ? "dodisplay" : "dontdisplay"}></FavoriteIcon>
                </div>
                <div className="info">
                    <iframe className="iframe" src={`https://embed.spotify.com/?uri=${props.info.uri}`} width="400px" height="100px" />
                </div>
                <div id={props.info.id} className={(liked) ? "dodisplayflex DeleteIconDiv" : "dontdisplay DeleteIconDiv"} onClick={deleted}>
                    <RemoveCircleOutlineIcon></RemoveCircleOutlineIcon>
                </div>
            </SongCardMain>
        )
    } else if (!props.info) {
        return (
            <div>loading page...</div>
        )
    }

}
